import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React from 'react';
import BottomModalNoticeButton from './BottomModalNoticeButton.js';
import BottomModalNoticeWrapper from './BottomModalNoticeWrapper.js';
import styles from './BottomModalNotice.module.scss.js';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
/**
 * BottomNavigationBar에 쓰이는 모달 (Text형)
 *
 * ```jsx
 * const {isShow, open, close} = useModal();
 *
 * const openModalText = open({
 *     type: BOTTOM_MODAL_NOTICE_TYPE.TEXT,
 *     title: <>...</>,
 *     subtext: <>...</>,
 *     button: { ... },
 *     underlineButton: { ... },
 *     onClickDimmedLayer: (event) => { console.info(event); close(); },
 *     onClickCloseButton: (event) => { console.info(event); close(); },
 * });
 * ```
 *
 * ### Provider 설정
 * `DefignProvider`를 컴포넌트 최상단에 선언해야 BottomModalNotice를 사용할 수 있습니다.
 *
 * ```jsx
 * <DefignProvider>
 *     {children}
 * </DefignProvider>
 * ```
 * ### 하단 버튼
 * `oneButton` 혹은 `twoButton` object 를 사용할 수 있으며, 이 두가지는 mutually exclusive하게 동작합니다.
 * - `oneButton`: `ButtonBox`(`size=BUTTON_BOX_SIZE.LARGE_FULL`로 고정)
 * - `twoButton`: `ButtonBoxDouble`(`size=BUTTON_BOX_SIZE.LARGE`로 고정)
 */
function BottomModalNoticeText(_ref) {
  var isPreRender = _ref.isPreRender,
    title = _ref.title,
    subtext = _ref.subtext,
    button = _ref.button,
    underlineButton = _ref.underlineButton,
    onClickDimmedLayer = _ref.onClickDimmedLayer,
    onClickCloseButton = _ref.onClickCloseButton;
  return /*#__PURE__*/React.createElement(BottomModalNoticeWrapper, {
    isPreRender: isPreRender,
    underlineButton: underlineButton,
    onClickDimmedLayer: onClickDimmedLayer,
    onClickCloseButton: onClickCloseButton
  }, /*#__PURE__*/React.createElement("strong", {
    className: cx('title')
  }, title), subtext ? /*#__PURE__*/React.createElement("p", {
    className: cx('subtext')
  }, subtext) : null, /*#__PURE__*/React.createElement("div", {
    className: cx('button-area', 'type-text')
  }, /*#__PURE__*/React.createElement(BottomModalNoticeButton, _objectSpread({}, button))));
}
/**
 * BottomNavigationBar에 쓰이는 모달 (Image형)
 *
 * ```jsx
 * const {isShow, open, close} = useModal();
 *
 * const openModalImage = open({
 *     type: BOTTOM_MODAL_NOTICE_TYPE.IMAGE,
 *     title: <>...</>,
 *     subtext: <>...</>,
 *     image: <>...</>,
 *     imagePosition: 'top', // 'top' | 'bottom'
 *     button: { ... },
 *     underlineButton: { ... },
 *     onClickDimmedLayer: (event) => { console.info(event); close(); },
 *     onClickCloseButton: (event) => { console.info(event); close(); },
 * });
 * ```
 *
 * ### Provider 설정
 * `DefignProvider`를 컴포넌트 최상단에 선언해야 BottomModalNotice를 사용할 수 있습니다.
 *
 * ```jsx
 * <DefignProvider>
 *     {children}
 * </DefignProvider>
 * ```
 *
 * ### 하단 버튼
 * `oneButton` 혹은 `twoButton` object 를 사용할 수 있으며, 이 두가지는 mutually exclusive하게 동작합니다.
 * - `oneButton`: `ButtonBox`(`size=BUTTON_BOX_SIZE.LARGE_FULL`로 고정)
 * - `twoButton`: `ButtonBoxDouble`(`size=BUTTON_BOX_SIZE.LARGE`로 고정)
 */
function BottomModalNoticeImage(_ref2) {
  var isPreRender = _ref2.isPreRender,
    title = _ref2.title,
    subtext = _ref2.subtext,
    image = _ref2.image,
    imagePosition = _ref2.imagePosition,
    button = _ref2.button,
    underlineButton = _ref2.underlineButton,
    onClickDimmedLayer = _ref2.onClickDimmedLayer,
    onClickCloseButton = _ref2.onClickCloseButton;
  return /*#__PURE__*/React.createElement(BottomModalNoticeWrapper, {
    isPreRender: isPreRender,
    underlineButton: underlineButton,
    onClickDimmedLayer: onClickDimmedLayer,
    onClickCloseButton: onClickCloseButton
  }, imagePosition === 'top' && /*#__PURE__*/React.createElement("div", {
    className: cx('image-area')
  }, image), /*#__PURE__*/React.createElement("strong", {
    className: cx('title')
  }, title), subtext ? /*#__PURE__*/React.createElement("p", {
    className: cx('subtext')
  }, subtext) : null, imagePosition === 'bottom' && /*#__PURE__*/React.createElement("div", {
    className: cx('image-area')
  }, image), /*#__PURE__*/React.createElement("div", {
    className: cx('button-area')
  }, /*#__PURE__*/React.createElement(BottomModalNoticeButton, _objectSpread({}, button))));
}
/**
 * BottomNavigationBar에 쓰이는 모달 (Full형)
 *
 * ```jsx
 * const {isShow, open, close} = useModal();
 *
 * const openModalFull = open({
 *     type: BOTTOM_MODAL_NOTICE_TYPE.FULL,
 *     image: <div style={{backgroundColor: '#E3F6ED', height: 212}}>이미지 영역</div>,
 *     button: {
 *         oneButton: {text: '지금 개설하기', variant: BUTTON_VARIANT.PRIMARY, color: BUTTON_PRIMARY_COLOR.GREEN},
 *     },
 *     underlineButton: {
 *         text: '7일간 보지 않기',
 *         color: BUTTON_TEXT_UNDERLINE_COLOR.GRAY700,
 *     },
 *     onClickDimmedLayer: (event) => { console.info(event); close(); },
 *     onClickCloseButton: (event) => { console.info(event); close(); },
 * });
 * ```
 *
 * ### Provider 설정
 * `DefignProvider`를 컴포넌트 최상단에 선언해야 BottomModalNotice를 사용할 수 있습니다.
 *
 * ```jsx
 * <DefignProvider>
 *     {children}
 * </DefignProvider>
 * ```
 *
 * ### 하단 버튼
 * `oneButton` 혹은 `twoButton` object 를 사용할 수 있으며, 이 두가지는 mutually exclusive하게 동작합니다.
 * - `oneButton`: `ButtonBox`(`size=BUTTON_BOX_SIZE.LARGE_FULL`로 고정)
 * - `twoButton`: `ButtonBoxDouble`(`size=BUTTON_BOX_SIZE.LARGE`로 고정)
 */
function BottomModalNoticeFull(_ref3) {
  var isPreRender = _ref3.isPreRender,
    image = _ref3.image,
    button = _ref3.button,
    underlineButton = _ref3.underlineButton,
    onClickDimmedLayer = _ref3.onClickDimmedLayer,
    onClickCloseButton = _ref3.onClickCloseButton;
  return /*#__PURE__*/React.createElement(BottomModalNoticeWrapper, {
    isPreRender: isPreRender,
    underlineButton: underlineButton,
    onClickDimmedLayer: onClickDimmedLayer,
    onClickCloseButton: onClickCloseButton
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('image-area')
  }, image), /*#__PURE__*/React.createElement("div", {
    className: cx('button-area', 'type-full')
  }, /*#__PURE__*/React.createElement(BottomModalNoticeButton, _objectSpread({}, button))));
}
/**
 * BottomNavigationBar에 쓰이는 모달 (Ad형)
 *
 * ```jsx
 * const {isShow, open, close} = useModal();
 *
 * const openModalAd = open({
 *     type: BOTTOM_MODAL_NOTICE_TYPE.AD,
 *     content: <>...</>,
 *     underlineButton: { ... },
 *     onClickDimmedLayer: (event) => { console.info(event); close(); },
 *     onClickCloseButton: (event) => { console.info(event); close(); },
 * });
 * ```
 *
 * ### Provider 설정
 * `DefignProvider`를 컴포넌트 최상단에 선언해야 BottomModalNotice를 사용할 수 있습니다.
 *
 * ```jsx
 * <DefignProvider>
 *     {children}
 * </DefignProvider>
 * ```
 */
function BottomModalNoticeAd(_ref4) {
  var isPreRender = _ref4.isPreRender,
    content = _ref4.content,
    underlineButton = _ref4.underlineButton,
    onClickDimmedLayer = _ref4.onClickDimmedLayer,
    onClickCloseButton = _ref4.onClickCloseButton;
  return /*#__PURE__*/React.createElement(BottomModalNoticeWrapper, {
    isPreRender: isPreRender,
    underlineButton: underlineButton,
    onClickDimmedLayer: onClickDimmedLayer,
    onClickCloseButton: onClickCloseButton
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('ad')
  }, content));
}

export { BottomModalNoticeAd, BottomModalNoticeFull, BottomModalNoticeImage, BottomModalNoticeText };
